import BasicTable from 'Components/UI/Atoms/BasicTable'

const Asientos = ({ data }) => {
  return (
    <>
      <div style={{ display: 'flex', margin: '2rem' }}>
        <BasicTable
          col={[
            { title: 'ID', style: { width: '40px' } },
            { title: 'Fecha', style: { width: '40px' } },
            { title: 'Descripción', style: { width: '100px' } },
            { title: 'Debe', style: { width: '60px' } },
            { title: 'Haber', style: { width: '60px' } },
          ]}
          size="small"
          rows={data.asientos.map((row) => {
            const debeTotal = row.detalles.reduce(
              (acc, detalle) => acc + parseFloat(detalle.debe),
              0
            )
            const haberTotal = row.detalles.reduce(
              (acc, detalle) => acc + parseFloat(detalle.haber),
              0
            )

            return {
              id: row.id,
              fecha: row.fecha,
              descripcion: row.descripcion,
              debe: `$ ${debeTotal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
              haber: `$ ${haberTotal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
            }
          })}
        />
      </div>
    </>
  )
}

export default Asientos
